import { render, staticRenderFns } from "./cash-drawers.vue?vue&type=template&id=6951c514&scoped=true&"
import script from "./cash-drawers.vue?vue&type=script&lang=js&"
export * from "./cash-drawers.vue?vue&type=script&lang=js&"
import style0 from "./cash-drawers.vue?vue&type=style&index=0&id=6951c514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6951c514",
  null
  
)

export default component.exports